import {Action} from '@ngrx/store';

export const ADD_WORKBOOK_INFO = '[Spreadsheet] ADD_WORKBOOK_INFO';

export class AddWorkbookInfoAction implements Action {
  readonly type = ADD_WORKBOOK_INFO;
  constructor(public workbookId: string, public worksheetId: string) {
  }
}

export const GET_CBC_FORMS = '[Spreadsheet] GET_CBC_FORMS';

export class GetCbcFormsAction implements Action {
  readonly type = GET_CBC_FORMS;
  constructor(public countryCode: string) {
  }
}

export const GET_CBC_FORMS_SUCCESS = '[Spreadsheet] GET_CBC_FORMS_SUCCESS';

export class GetCbcFormsSuccessAction implements Action {
  readonly type = GET_CBC_FORMS_SUCCESS;
  constructor(public countryCode: string, public cbcForms: any[]) {
  }
}

export type SpreadsheetActions = AddWorkbookInfoAction | GetCbcFormsAction | GetCbcFormsSuccessAction;
